import { useMemo, useState, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- any is correct for this usage
export function createBreakpointHook<Size extends keyof any>(sizes: (Record<Size, number>)) {
  //TODO(nibeauli): sanity check the provided sizes when in debug mode
  // Calculate the breakpoint map based on the included size map.
  const orderedSizes = (Object.entries(sizes) as [Size, number][]).sort((a, b) => a[1] - b[1]);
  const breakpoints = orderedSizes.map(([size, low], index) => {
    const nextSize = orderedSizes[index + 1] as [Size, number] | undefined;
    const query = nextSize
      ? `(min-width: ${low.toString()}px) and (max-width: ${(nextSize[1] - 1).toString()}px)`
      : `(min-width: ${low.toString()}px)`;
    return { size, mediaQueryList: window.matchMedia(query) }
  });

  const initial = breakpoints.find(bp => bp.mediaQueryList.matches) ?? breakpoints[0];

  return function useBreakpoints() {
    const [size, setSize] = useState<Size>(initial.size);

    const listeners = useMemo(() => breakpoints.map(bp => ({
      listener: (e: MediaQueryListEvent) => {
        if (e.matches) {
          setSize(bp.size);
        }
      }
    })), [breakpoints]);

    // hook it all up to react
    useEffect(() => {
      listeners.forEach(({ listener }, index) => {
        breakpoints[index].mediaQueryList.addEventListener('change', listener);
      });
      return () => {
        listeners.forEach(({ listener }, index) => {
          breakpoints[index].mediaQueryList.removeEventListener('change', listener);
        });
      };
    }, [breakpoints]);

    return size;
  }
}
